export const MAX_DESCRIPTION_LENGTH = 100
export const R_TOYS_ID = 2196
export const PLATFORM_ID = 1
